import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { OtpResponse } from '../interfaces/api/otp';

@Injectable({
  providedIn: 'root',
})
export class OtpService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
  }

  createOtp(payload: any) {
    return this.http.post<OtpResponse>(`${this.apiUrl}/send-otp-wa`, {
      ...payload,
      no_loading: true,
    });
  }

  validateOtp(payload: any) {
    return this.http.post(`${this.apiUrl}/verify-otp`, payload);
  }
}
